module.exports = __webpack_public_path__ + "static/media/ehealth_minor_redemption_banner_mobile.b950b033.jpg";